import { useState, useEffect, useContext, useCallback  } from 'react';
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';
import dayjs from 'dayjs';


export default function ReportSnippetInfo(props) {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)

      
  useEffect(() => {
      //console.log(params)
      setSnippetInfo(props.snippetInfo)
  }, [props.snippetInfo])

  const formatDate = (d) => {
    const djs = new dayjs(d)

    return djs.format('DD/MM/YYYY') 
  }

    return <div className='text-ccColorDarkTeal'>
            {snippetInfo && <>
              <div className='text-xl font-semibold'>Element Name: {snippetInfo.snippetName}</div>
              <div className='italic font-semibold'>Element Description: {snippetInfo.snippetDesc}</div>
              <div className='flex flex-row gap-x-1'><Iconify icon="uil:calendar" width={22} /><div>{formatDate(snippetInfo.created)}</div></div>
            </>
            }

    </div>
}